import React from 'react'

export default function Warning() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7087 8.38274L6.35914 28.6913C6.12514 29.1256 6.00132 29.6181 6.00001 30.1196C5.9987 30.6212 6.11994 31.1144 6.35167 31.5501C6.5834 31.9859 6.91753 32.349 7.32084 32.6034C7.72415 32.8577 8.18256 32.9945 8.65048 33H31.3495C31.8174 32.9945 32.2759 32.8577 32.6792 32.6034C33.0825 32.349 33.4166 31.9859 33.6483 31.5501C33.8801 31.1144 34.0013 30.6212 34 30.1196C33.9987 29.6181 33.8749 29.1256 33.6409 28.6913L22.2913 8.38274C22.0525 7.96063 21.7161 7.61164 21.3148 7.36944C20.9134 7.12724 20.4606 7 20 7C19.5394 7 19.0866 7.12724 18.6852 7.36944C18.2839 7.61164 17.9475 7.96063 17.7087 8.38274V8.38274Z"
        stroke="#9F1D16"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 13L20 23"
        stroke="#9F1D16"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="20" cy="28" r="2" fill="#9F1D16" />
    </svg>
  )
}
